module.exports = __webpack_public_path__ + "static/media/vgr_logo.6526ca5f.svg";